import main from './lib/main.vue';

export default main;
